import gql from 'graphql-tag';

// note: the backend currently throttles the number of items you can fetch to 1000
export const IMPORT_PANEL_MENU_PROJECTS = gql`
  query ImportPanelMenuProjects(
    $userName: String!
    $selectedEntityName: String
    $projectSearchQuery: String
  ) {
    entity(name: $selectedEntityName) {
      id
      ...ImportPanelMenuEntityFragment
    }
    user(userName: $userName) {
      id
      teams {
        edges {
          node {
            id
            ...ImportPanelMenuEntityFragment
          }
        }
      }
    }
  }
  fragment ImportPanelMenuEntityFragment on Entity {
    id
    name
    projects(order: "-created_at", first: 10000, pattern: $projectSearchQuery) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

// Get all views associated with a project so we can look at the owning user
// and fetch just the user's viewspec in the next query.
export const IMPORT_PANEL_MENU_VIEWS = gql`
  query ImportPanelMenuViews(
    $entityName: String
    $projectName: String
    $userName: String
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      allViews(viewType: "project-view", userName: $userName) {
        edges {
          node {
            id
            ...ImportPanelProjectViewsFragment
          }
        }
      }
    }
  }
  fragment ImportPanelProjectViewsFragment on View {
    id
    name
    user {
      id
      username
    }
  }
`;

// Get just the viewspec for a single view:
export const IMPORT_PANEL_MENU_VIEW_SPEC = gql`
  query ImportPanelMenuViewSpec($viewId: ID!) {
    view(id: $viewId) {
      id
      spec
    }
  }
`;
